import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Chip from '@material-ui/core/Chip';

const styles = theme => ({
    root: {
        borderRadius: '4px',
        backgroundColor: theme.palette.red,
        fontSize: props => props.size === 'small' && '75%',
        height: props => (props.size === 'small' ? 20 : 30),
    },
    colorActive: {
        backgroundColor: theme.palette.green,
    },
    colorDisabled: {
        backgroundColor: theme.palette.primary.main,
    },

    colorDefault: {
        backgroundColor: theme.palette.yellow,
    },
});

const StatusChip = props => {
    const { classes, label, variant = 'default', size } = props;

    return (
        <Chip
            color="primary"
            label={label}
            size={size}
            className={classNames(classes.root, {
                [classes.colorActive]: variant === 'active',
                [classes.colorDisabled]: variant === 'disabled',
                [classes.colorDefault]: variant === 'default',
            })}
        />
    );
};

export default withStyles(styles)(StatusChip);
